'use client';
import { createContext, createElement } from 'react';
import { Hydrate } from './hydrate.js';
export const BigmiContext = createContext(undefined);
export function BigmiProvider(parameters) {
    const { children, config } = parameters;
    const props = { value: config };
    return createElement(Hydrate, parameters, createElement(BigmiContext.Provider, props, children));
}
//# sourceMappingURL=context.js.map